var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('div', {
    staticClass: "pcoded-inner-content"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-2 "
  }, [_c('b-card', {
    staticClass: "text-white bg-success"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.clientCount.onboardClientCount))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Total Clients Onboarded")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totalClient
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white info"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.clientCount.activeClientCount))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Total Active Clients")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totaActiveClient
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-danger"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-hourglass"
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.pendingclientcont))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Client Pending Approval")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totalPendingApprovalClient
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-warning1"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-speech"
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.pendingclientcont))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Client Pending Approval")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totalPendingApprovalClient
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white primary"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.pendingclientcont))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Client Pending Approval")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totalPendingApprovalClient
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white succid"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4",
    staticStyle: {
      "padding": "0px 0px 10px"
    }
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.dashBoardArr), function(data, index) {
    return _c('div', [_c('div', {
      staticClass: "h4 mb-0"
    }, [_vm._v(_vm._s(data.pendingclientcont))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted text-uppercase font-weight-bold"
    }, [_vm._v("Client Pending Approval")]), _vm._v(" "), _c('b-progress', {
      staticClass: "progress-white progress-xs mt-3",
      attrs: {
        "max": _vm.max,
        "value": _vm.totalPendingApprovalClient
      }
    })], 1)
  })], 2)], 1)])])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504d869f","hasScoped":true}!./src/views/components/cargoclient/clientdashboard/clientdashboard.component.html
// module id = 538
// module chunks = 3